require('./passManagerController');

"use strict";

angular.module('app.admin.passManager', [
    'app.admin.passManager.passManagerController'
])
.config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('app.admin.passManager', {
            url: '/pass_manager/:teamId',
            controller: 'app.admin.passManager.passManagerController',
            templateUrl: 'components/admin/passManager/passManagerView.html',
            title: 'Pass Manager'
        });
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/passManager/passManager.js